import Redaction from './Redaction.container';

export default Redaction;
